import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { DateFormat, formatDate } from '@cp/src/utils/DateHelper';

const SuccessFooter = () => {
  const summaryData = useSelector((state: RootState) => state.allocations?.summaryData);
  return (
    <div className="w-full bg-[var(--navi-color-green-bg)] h-9 flex items-center justify-between">
      <div className="flex items-center gap-2 mx-6">
        <Typography variant="h4" color="var(--navi-color-gray-c2)">
          Status :
        </Typography>
        <Typography variant="h4" color="var(--navi-color-green-dark)">
          SUCCESS
        </Typography>
      </div>
      <Typography variant="h4" color="var(--navi-color-green-dark)" className="mr-4">
        {formatDate(summaryData?.allocationCompletedAt, DateFormat.DD_MMM_YYYY__hh_mm_a)}
      </Typography>
    </div>
  );
};

export default SuccessFooter;
